var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0007 20.1875C13.9815 20.1875 9.89648 16.1025 9.89648 11.0833C9.89648 6.06413 13.9815 1.97913 19.0007 1.97913C24.0198 1.97913 28.1048 6.06413 28.1048 11.0833C28.1048 16.1025 24.0198 20.1875 19.0007 20.1875ZM19.0007 4.35413C15.2957 4.35413 12.2715 7.37829 12.2715 11.0833C12.2715 14.7883 15.2957 17.8125 19.0007 17.8125C22.7057 17.8125 25.7298 14.7883 25.7298 11.0833C25.7298 7.37829 22.7057 4.35413 19.0007 4.35413Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6001 36.0208C31.9509 36.0208 31.4126 35.4825 31.4126 34.8333C31.4126 29.3708 25.8393 24.9375 18.9993 24.9375C12.1593 24.9375 6.58594 29.3708 6.58594 34.8333C6.58594 35.4825 6.0476 36.0208 5.39844 36.0208C4.74927 36.0208 4.21094 35.4825 4.21094 34.8333C4.21094 28.0725 10.8451 22.5625 18.9993 22.5625C27.1534 22.5625 33.7876 28.0725 33.7876 34.8333C33.7876 35.4825 33.2493 36.0208 32.6001 36.0208Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserWhite);
export default __webpack_public_path__ + "static/media/user-white.77d6c950c7d0304cc2e584522b477f5a.svg";
export { ForwardRef as ReactComponent };